/* ============================================================================
   EAGLE VIEW 2 - comportamiento
   Tesis de movimiento: la pagina es un descenso. Un unico momento de autoria,
   la TRANSMISION (el movil fijo como visor), y movimiento de apoyo que solo
   explica estado, relacion o continuidad. Nada decorativo.
   Todo el contenido es visible por defecto: si el JS falla, no se esconde nada.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.remove('no-js');

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduced = RM.matches;
  var hasGSAP = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
  if (hasGSAP) gsap.registerPlugin(ScrollTrigger);

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var pad = function (n, w) { n = String(Math.max(0, Math.round(n))); while (n.length < w) n = '0' + n; return n; };

  /* ---------------------------------------------------------------- ARRANQUE
     Secuencia de encendido del instrumento. Corta (~1,4 s) y saltable.
     Con movimiento reducido no existe: el CSS ya la oculta.                  */
  function boot(done) {
    var el = $('#ev2Boot');
    if (!el || reduced || !hasGSAP) { if (el) el.remove(); document.body.classList.remove('ev2-booting'); done(); return; }

    var lines = $$('.ev2-boot__ln', el);
    var bar = $('.ev2-boot__bar i', el);
    var pc = $('#ev2BootPc');
    var tl = gsap.timeline({
      onComplete: function () {
        gsap.to(el, {
          opacity: 0, duration: .45, ease: 'power2.out',
          onComplete: function () { el.remove(); document.body.classList.remove('ev2-booting'); done(); }
        });
      }
    });
    tl.to(lines, { opacity: 1, duration: .01, stagger: .13 }, 0)
      .fromTo(bar, { scaleX: 0 }, { scaleX: 1, duration: 1.25, ease: 'power2.inOut' }, .05)
      .to({ v: 0 }, {
        v: 100, duration: 1.25, ease: 'power2.inOut',
        onUpdate: function () { if (pc) pc.textContent = pad(this.targets()[0].v, 3) + '%'; }
      }, .05)
      .to({}, { duration: .2 });

    // saltable: cualquier interaccion termina el arranque
    ['click', 'keydown', 'touchstart', 'wheel'].forEach(function (ev) {
      window.addEventListener(ev, function once() {
        window.removeEventListener(ev, once);
        if (tl.isActive()) tl.progress(1);
      }, { passive: true, once: true });
    });
  }

  /* ------------------------------------------------------------------ HERO
     Entrada autoral: el titular sube tras una mascara; el fondo se asienta.  */
  function hero() {
    var t = $('#ev2Hero');
    if (!t) return;
    var lines = $$('.ev2-hero__t .ev2-ln > span', t);
    var bg = $('.ev2-hero__bg img', t);
    var rest = $$('.ev2-hero__row, .ev2-sh', t);

    if (!hasGSAP || reduced) {
      if (bg && !reduced) gsap.set && gsap.set(bg, { scale: 1.06 });
      return;
    }
    gsap.set(lines, { yPercent: 108 });
    gsap.set(rest, { opacity: 0, y: 14 });

    var tl = gsap.timeline();
    tl.fromTo(bg, { scale: 1.24 }, { scale: 1.1, duration: 1.9, ease: 'power3.out' }, 0)
      .to(lines, { yPercent: 0, duration: .95, ease: 'expo.out', stagger: .085 }, .12)
      .to(rest, { opacity: 1, y: 0, duration: .7, ease: 'power3.out', stagger: .09 }, .62);

    // asentamiento al salir: el fondo sigue bajando, el texto se despide
    gsap.to(bg, {
      yPercent: 11, ease: 'none',
      scrollTrigger: { trigger: t, start: 'top top', end: 'bottom top', scrub: true }
    });
  }

  /* ------------------------------------------------------------------- HUD
     Continuidad: una sola lectura, la altitud, que solo baja. Explica en que
     punto del descenso esta el visitante y une todas las secciones.         */
  function hud() {
    var alt = $('#ev2Alt'), fill = $('#ev2AltFill'), pcEl = $('#ev2Pc');
    if (!alt && !fill) return;
    var MAX = 9000, raf = null;

    function read() {
      raf = null;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0;
      if (alt) alt.textContent = pad(MAX * (1 - p), 4);
      if (pcEl) pcEl.textContent = pad(p * 100, 3);
      if (fill) fill.style.transform = 'scaleY(' + p.toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(read); }, { passive: true });
    window.addEventListener('resize', read);
    read();
  }

  /* -------------------------------------------------------------- MARQUESINA
     Bucle continuo; se detiene cuando no se ve (nada corre fuera de pantalla).*/
  function band() {
    var tr = $('#ev2Band');
    if (!tr || !hasGSAP || reduced) return;
    var half = tr.scrollWidth / 2;
    var tw = gsap.to(tr, { x: -half, duration: 26, ease: 'none', repeat: -1 });
    ScrollTrigger.create({
      trigger: tr.parentNode,
      onToggle: function (s) { s.isActive ? tw.play() : tw.pause(); }
    });
  }

  /* ------------------------------------------------------- REVELADO POR LINEA
     Apoyo, no espectaculo: una sola entrada por bloque, nunca en cada hijo.  */
  function reveals() {
    if (!hasGSAP || reduced) return;
    $$('[data-rv]').forEach(function (el) {
      var kids = $$('.ev2-rv > span', el);
      var targets = kids.length ? kids : [el];
      gsap.set(targets, kids.length ? { yPercent: 104 } : { opacity: 0, y: 18 });
      gsap.to(targets, {
        yPercent: kids.length ? 0 : undefined,
        opacity: kids.length ? undefined : 1,
        y: kids.length ? undefined : 0,
        duration: kids.length ? .9 : .7,
        ease: 'expo.out',
        stagger: Math.min(.07, .42 / Math.max(1, targets.length)),
        scrollTrigger: { trigger: el, start: 'top 86%', once: true }
      });
    });
  }

  /* ------------------------------------------- MANIFIESTO (barrido por frase)
     Se revela con clip-path, no con mascara de altura fija: asi cada frase
     puede ocupar las lineas que necesite a cualquier ancho sin cortarse.    */
  function clauses() {
    if (!hasGSAP || reduced) return;
    $$('[data-cl]').forEach(function (el) {
      var cl = $$('.ev2-cl', el);
      if (!cl.length) return;
      gsap.set(cl, { clipPath: 'inset(0 0 100% 0)', y: 10 });
      gsap.to(cl, {
        clipPath: 'inset(0 0 0% 0)', y: 0, duration: .85, ease: 'expo.out', stagger: .11,
        scrollTrigger: { trigger: el, start: 'top 82%', once: true }
      });
    });
  }

  /* ---------------------------------------------------------------- NAV
     Sobre la foto se mezcla por diferencia; sobre el texto se asienta con
     fondo propio, que si no se cruzan las dos cosas.                       */
  function nav() {
    var n = $('.ev2-nav'), hero = $('#ev2Hero');
    if (!n) return;
    var raf = null;
    function read() {
      raf = null;
      var lim = hero ? hero.offsetHeight - 80 : 400;
      n.classList.toggle('is-stuck', window.scrollY > lim);
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(read); }, { passive: true });
    read();
  }

  /* ========================================================== TRANSMISION
     EL MOMENTO. El movil queda fijo como visor mientras el archivo pasa por
     dentro. El fondo es el mismo fotograma desenfocado: la unica ventana
     nitida del plano es la pantalla del movil.                              */
  function transmision() {
    var sec = $('#ev2Tx');
    if (!sec) return;
    var vids = $$('.ev2-ph__scr video', sec);
    var bgs = $$('.ev2-tx__bg img', sec);
    var idx = $$('.ev2-tx__idx button', sec);
    var N = vids.length;
    if (!N) return;

    var kA = $$('[data-tx-a]', sec), kB = $$('[data-tx-b]', sec),
        kN = $$('[data-tx-n]', sec), kOf = $$('[data-tx-of]', sec);
    var tc = $('#ev2Tc');
    var cur = -1, visible = false, st = null;

    kOf.forEach(function (e) { e.textContent = '/ ' + pad(N, 2); });

    function paint(i) {
      var v = vids[i];
      kA.forEach(function (e) { e.textContent = v.dataset.a || ''; });
      kB.forEach(function (e) { e.textContent = v.dataset.b || ''; });
      kN.forEach(function (e) { e.textContent = pad(i + 1, 2); });
      idx.forEach(function (b, j) {
        b.classList.toggle('is-on', j === i);
        b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      bgs.forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
    }

    function show(i) {
      if (i === cur || i < 0 || i >= N) return;
      var prev = cur; cur = i;
      var vNew = vids[i];

      vids.forEach(function (v, j) {
        if (j === i) return;
        v.style.zIndex = (j === prev) ? 2 : 1;
        if (j !== prev) { v.style.opacity = 0; try { v.pause(); } catch (e) {} }
      });
      if (prev > -1) { vids[prev].style.opacity = 1; vids[prev].style.clipPath = 'inset(0 0 0 0)'; }

      vNew.style.zIndex = 3;
      vNew.style.opacity = 1;
      if (!vNew.dataset.loaded) { vNew.dataset.loaded = '1'; try { vNew.load(); } catch (e) {} }
      if (visible) { var p = vNew.play(); if (p && p.catch) p.catch(function () {}); }

      if (!hasGSAP || reduced) {
        vNew.style.clipPath = 'inset(0 0 0 0)';
      } else {
        // barrido vertical: el visor relee la imagen de arriba abajo
        gsap.fromTo(vNew,
          { clipPath: 'inset(0 0 100% 0)' },
          {
            clipPath: 'inset(0 0 0% 0)', duration: .62, ease: 'expo.out',
            onComplete: function () {
              if (prev > -1 && prev !== cur) { vids[prev].style.opacity = 0; try { vids[prev].pause(); } catch (e) {} }
            }
          });
      }
      paint(i);
    }

    // cronometro del clip activo: dato real, no adorno
    if (tc) {
      setInterval(function () {
        if (cur < 0 || !visible) return;
        var t = vids[cur].currentTime || 0;
        tc.textContent = pad(Math.floor(t / 60), 2) + ':' + pad(Math.floor(t % 60), 2) + ':' + pad((t % 1) * 25, 2);
      }, 90);
    }

    show(0);

    // el indice navega: con pin lleva al punto del scroll, sin pin cambia el clip
    idx.forEach(function (b, j) {
      b.addEventListener('click', function () {
        if (st && st.start != null) {
          window.scrollTo({ top: st.start + (st.end - st.start) * ((j + .5) / N), behavior: reduced ? 'auto' : 'smooth' });
        } else {
          visible = true; show(j);
          var p = vids[j].play(); if (p && p.catch) p.catch(function () {});
        }
      });
    });

    if (!hasGSAP || reduced) {
      // sin pin: se recorre con un observador, el contenido sigue completo
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible) { var p = vids[cur].play(); if (p && p.catch) p.catch(function () {}); }
            else try { vids[cur].pause(); } catch (err) {}
          });
        }, { threshold: .25 });
        io.observe(sec);
      }
      return;
    }

    st = ScrollTrigger.create({
      trigger: $('.ev2-tx__stage', sec),
      start: 'top top',
      end: '+=' + (N * 78) + '%',
      pin: true,
      pinSpacing: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onToggle: function (s) {
        visible = s.isActive;
        if (visible) { var p = vids[cur].play(); if (p && p.catch) p.catch(function () {}); }
        else vids.forEach(function (v) { try { v.pause(); } catch (e) {} });
      },
      onUpdate: function (s) {
        show(Math.min(N - 1, Math.floor(s.progress * N * 0.999)));
      }
    });

    // el visor acusa el scroll: inclinacion minima, solo transform
    var ph = $('.ev2-ph', sec);
    if (ph) {
      gsap.fromTo(ph, { rotateX: 7, y: 22 }, {
        rotateX: -5, y: -22, ease: 'none',
        scrollTrigger: {
          trigger: $('.ev2-tx__stage', sec), start: 'top top',
          end: '+=' + (N * 78) + '%', scrub: .6
        }
      });
    }
  }

  /* ---------------------------------------------------------------- REGISTRO
     Continuidad: la foto y el ano de la izquierda explican que fila se lee.  */
  function registro() {
    var sec = $('#ev2Reg');
    if (!sec || !hasGSAP) return;
    var rows = $$('.ev2-row', sec);
    var pics = $$('.ev2-reg__stage img', sec);
    var yr = $('#ev2RegYr'), nn = $('#ev2RegN');
    if (!rows.length) return;

    rows.forEach(function (r, i) {
      ScrollTrigger.create({
        trigger: r, start: 'top 62%', end: 'bottom 42%',
        onToggle: function (s) {
          if (!s.isActive) return;
          pics.forEach(function (p, j) { p.classList.toggle('is-on', j === i); });
          if (yr) yr.textContent = r.dataset.yr || '';
          if (nn) nn.textContent = pad(i + 1, 2) + ' / ' + pad(rows.length, 2);
        }
      });
    });
  }

  /* ----------------------------------------------------------------- DOSSIER
     El scroll vertical se convierte en recorrido horizontal. En movil y con
     movimiento reducido no existe: se usa la pila fija del CSS.             */
  function dossier() {
    var sec = $('#ev2Dos');
    if (!sec || !hasGSAP || reduced) return;
    var vp = $('.ev2-dos__vp', sec), tr = $('.ev2-dos__tr', sec);
    if (!vp || !tr) return;

    var mm = gsap.matchMedia();
    mm.add('(min-width: 861px)', function () {
      var dist = function () { return Math.max(0, tr.scrollWidth - vp.clientWidth); };
      var tw = gsap.to(tr, {
        x: function () { return -dist(); },
        ease: 'none',
        scrollTrigger: {
          trigger: sec, start: 'top top',
          end: function () { return '+=' + dist(); },
          pin: true, scrub: .8, invalidateOnRefresh: true, anticipatePin: 1
        }
      });
      // paralaje por capas dentro de cada panel
      $$('.ev2-pan', tr).forEach(function (pan) {
        var img = $('.ev2-pan__img', pan);
        if (!img) return;
        gsap.fromTo(img, { x: '-6%' }, {
          x: '6%', ease: 'none',
          scrollTrigger: { trigger: pan, containerAnimation: tw, start: 'left right', end: 'right left', scrub: true }
        });
      });
      return function () { tw.scrollTrigger && tw.scrollTrigger.kill(); tw.kill(); gsap.set(tr, { x: 0 }); };
    });
  }

  /* ------------------------------------------------------------- DECLARACION
     La imagen se descompone en tiras y se recompone: la frase se gana.      */
  function declaracion() {
    var sec = $('#ev2Dec');
    if (!sec) return;
    var sts = $$('.ev2-dec__st', sec);
    var n = sts.length;
    // reparto del fondo entre las tiras (una sola imagen, sin peticiones extra)
    sts.forEach(function (s, i) { s.style.backgroundPosition = (n > 1 ? (i / (n - 1)) * 100 : 50) + '% center'; });
    if (!hasGSAP || reduced) return;

    gsap.fromTo(sts,
      { yPercent: function (i) { return i % 2 ? 13 : -13; } },
      {
        yPercent: 0, ease: 'none',
        scrollTrigger: { trigger: sec, start: 'top bottom', end: 'center center', scrub: .7 }
      });
    var lines = $$('.ev2-dec__t .ev2-ln > span', sec);
    gsap.set(lines, { yPercent: 106 });
    gsap.to(lines, {
      yPercent: 0, duration: .95, ease: 'expo.out', stagger: .1,
      scrollTrigger: { trigger: sec, start: 'top 55%', once: true }
    });
  }

  /* -------------------------------------------------------------- CTA + PIE */
  function cierre() {
    var bg = $('.ev2-cta__bg img');
    if (bg && hasGSAP && !reduced) {
      gsap.fromTo(bg, { yPercent: -7 }, {
        yPercent: 7, ease: 'none',
        scrollTrigger: { trigger: '.ev2-cta', start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }
  }

  /* ----------------------------------------------------------------- CURSOR
     Retícula de puntería. Solo con raton fino; nunca en tactil.             */
  function cursor() {
    var c = $('#ev2Cur');
    if (!c || reduced || !window.matchMedia('(pointer:fine)').matches) { if (c) c.remove(); return; }
    var x = window.innerWidth / 2, y = window.innerHeight / 2, cx = x, cy = y;
    document.addEventListener('mousemove', function (e) { x = e.clientX; y = e.clientY; }, { passive: true });
    (function loop() {
      cx += (x - cx) * .22; cy += (y - cy) * .22;
      c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('mouseover', function (e) {
      c.classList.toggle('is-hot', !!(e.target.closest && e.target.closest('a,button')));
    });
  }

  /* ------------------------------------------------------------------ AUDIO
     Nunca en autoplay. Solo suena si el visitante lo pide, y se para al salir.*/
  function audio() {
    var btn = $('#ev2AudioBtn'), au = $('#ev2Audio');
    if (!btn || !au) return;
    au.volume = 0;
    btn.addEventListener('click', function () {
      if (au.paused) {
        var p = au.play();
        if (p && p.catch) p.catch(function () {});
        btn.classList.add('is-on');
        btn.setAttribute('aria-pressed', 'true');
        if (hasGSAP) gsap.to(au, { volume: .4, duration: 1.1 }); else au.volume = .4;
      } else {
        btn.classList.remove('is-on');
        btn.setAttribute('aria-pressed', 'false');
        if (hasGSAP) gsap.to(au, { volume: 0, duration: .5, onComplete: function () { au.pause(); } });
        else { au.volume = 0; au.pause(); }
      }
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && !au.paused) { au.pause(); btn.classList.remove('is-on'); btn.setAttribute('aria-pressed', 'false'); }
    });
  }

  /* --------------------------------------------------------------- ARRANCAR */
  function start() {
    hud(); nav(); cursor(); audio(); band(); reveals(); clauses();
    transmision(); registro(); dossier(); declaracion(); cierre();
    if (hasGSAP) {
      // las fuentes cambian la altura: recalcular cuando esten listas
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
      window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    }
  }

  function init() { boot(function () { hero(); }); start(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
